<template>
  <proa-modal
    :modal="modal"
    :title="$t('common.confirm')"
    @close="$emit('close')"
  >
    <proa-heading v-if="deleteProjectAttachment" sub>
      {{ `「${deleteProjectAttachment.attachmentFileName}」${$t('common.modals.deleteProjectAttachmentModal.confirmMessage')}` }}
    </proa-heading>
    <template v-slot:footer>
      <proa-button
        @click.native="$emit('close')"
        :disabled="requesting"
        class="mr-2"
      >
        {{ $t('common.cancel') }}
      </proa-button>
      <proa-button
        @click.native="$emit('onConfirmedDeleteProjectAttachment')"
        :loading="requesting"
        variant="secondary"
      >
        {{ $t('common.delete') }}
      </proa-button>
    </template>
  </proa-modal>
</template>

<script>
export default {
  name: 'DeleteProjectAttachmentModal',
  props: {
    modal: Boolean,
    requesting: Boolean,
    deleteProjectAttachment: Object
  }
}
</script>
